import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink as ReactNavLink, useLocation } from 'react-router-dom';
import { DefaultLinkSimple } from './DefaultLinkSimple';
export const NavLinkSimple = (_a) => {
    var { children, forceDefaultLink = false, to } = _a, otherProps = __rest(_a, ["children", "forceDefaultLink", "to"]);
    let insideReactRouter;
    try {
        useLocation();
        insideReactRouter = true;
    }
    catch (_b) {
        insideReactRouter = false;
    }
    if (forceDefaultLink || !insideReactRouter) {
        return (_jsx(DefaultLinkSimple, Object.assign({}, otherProps, { href: typeof to === 'string' ? to : undefined, children: children })));
    }
    return (_jsx(ReactNavLink, Object.assign({}, otherProps, { "data-testid": "react-navlink-element", to: to, children: children })));
};
//# sourceMappingURL=NavLinkSimple.js.map